import type { AreaSubstrate } from 'paintscout'

/**
 * Creates a new areaSubstrate with defaults and given key
 * @param key - key of new areaSubstrate
 * @returns
 */
export default function createBaseAreaSubstrate(key: string): AreaSubstrate {
  return {
    type: 'areaSubstrate' as const,
    key,
    quantity: 1,
    hours: 0,
    price: 0,
    prep: 0,
    coats: 1,
    show: true,
    show_price: true,
    show_crew: true,
    use_total: true,
    client_label: '',
    hourlyRate: null,
    products: [],
    rate: null,
    section: {
      value: ''
    },
    notes: '',
    rate_value: 0,
    override_dimensions: false,
    override_hours: false,
    override_price: false,
    override_price_value: 0,
    length: 0,
    height: 0,
    width: 0
  }
}
